/* eslint-disable react/display-name */
import React, { forwardRef, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { calSubTotal } from "../../../../../../../../../store/Concept/actions";
import { selectedArticles } from "../../../../../../../../../store/Concept/selectors";
import { isSelected } from "../../../../../../../../../utils/functions";
import { CheckboxContainer, HiddenCheckbox, StyledCheckbox, Icon } from "./styled";

const Checkbox = forwardRef(({ indeterminate, show, row, addItem, ...rest }, ref) => {
  const dispatch = useDispatch();
  const defaultRef = useRef();
  const resolvedRef = ref || defaultRef;
  const items = useSelector(selectedArticles);

  const onClick = () => {
    dispatch(addItem(row.original));
    dispatch(calSubTotal(row.original.id));
  };

  if (show) {
    return null;
  }

  useEffect(() => {
    resolvedRef.current.indeterminate = indeterminate;
  }, [resolvedRef, indeterminate]);

  return (
    <CheckboxContainer checked={isSelected(items, row.original.id)}>
      <HiddenCheckbox ref={resolvedRef} {...rest} checked={isSelected(items, row.original.id)} />
      <StyledCheckbox
        ref={resolvedRef}
        {...rest}
        checked={isSelected(items, row.original.id)}
        onClick={() => dispatch(onClick())}
      >
        <Icon viewBox="0 0 24 24">
          <polyline points="20 6 9 17 4 12" />
        </Icon>
      </StyledCheckbox>
    </CheckboxContainer>
  );
});

export default Checkbox;
